// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2HGUq","item":"PaymentsMobile_item__t6pwl","label":"PaymentsMobile_label__3Pstd","amount":"PaymentsMobile_amount__1OPkn"};